import { formatMoney } from '@/utils/format';

interface MobileProvider {
  id: string;
  label: string;
  hint: string;
  icon: string;
}

interface TopUpMobileMoneyProps {
  providers: MobileProvider[];
  providerId: string;
  onProvider: (id: string) => void;
  phone: string;
  onPhone: (value: string) => void;
  currency: string;
  amount: number;
}

export default function TopUpMobileMoney({
  providers,
  providerId,
  onProvider,
  phone,
  onPhone,
  currency,
  amount,
}: TopUpMobileMoneyProps) {
  return (
    <div className="space-y-4">
      <div>
        <p className="mb-1.5 text-xs font-label font-medium text-foreground-700">
          Choose your mobile money network
        </p>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {providers.map((provider) => {
            const active = provider.id === providerId;
            return (
              <button
                key={provider.id}
                type="button"
                onClick={() => onProvider(provider.id)}
                className={`flex items-center gap-2.5 rounded-md border px-3 py-2.5 text-left transition-colors cursor-pointer ${
                  active
                    ? 'border-primary-400 bg-primary-50'
                    : 'border-background-300 bg-background-50 hover:bg-background-100'
                }`}
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background-100 text-base text-foreground-600">
                  <i className={provider.icon} />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm text-foreground-900">{provider.label}</span>
                  <span className="block truncate text-[11px] text-foreground-500">
                    {provider.hint}
                  </span>
                </span>
                <i
                  className={
                    active
                      ? 'ri-checkbox-circle-fill text-primary-500'
                      : 'ri-circle-line text-foreground-300'
                  }
                />
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <label
          htmlFor="topup-momo-phone"
          className="mb-1.5 block text-xs font-label font-medium text-foreground-700"
        >
          Phone number to receive the prompt
        </label>
        <div className="flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3">
          <span className="w-4 h-4 flex items-center justify-center text-foreground-500">
            <i className="ri-smartphone-line" />
          </span>
          <input
            id="topup-momo-phone"
            type="tel"
            inputMode="tel"
            value={phone}
            onChange={(event) => onPhone(event.target.value)}
            placeholder="+254 7XX XXX XXX"
            className="h-10 w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
          />
        </div>
      </div>

      <div className="rounded-md border border-secondary-200 bg-secondary-50 px-3 py-2.5">
        <div className="flex items-center justify-between text-sm">
          <span className="text-foreground-500">Collection amount</span>
          <span className="font-medium text-foreground-950">{formatMoney(amount, currency)}</span>
        </div>
        <p className="mt-1.5 flex items-start gap-2 text-[11px] leading-relaxed text-secondary-900">
          <span className="mt-0.5 w-3.5 h-3.5 flex items-center justify-center shrink-0">
            <i className="ri-notification-3-line" />
          </span>
          A push notification is triggered on the number above. Approve it on your phone to credit
          the wallet instantly.
        </p>
      </div>
    </div>
  );
}